import React from "react";
import chatPerson from "../../../images/img/chat-person.png";

const MessageA3 = (props) => {
  return (
    <>
      {" "}
      <div style={{ display: "flex", width: "100%" }}>
        <div className="chat-person" style={{ marginTop: "10px" }}>
          <img src={chatPerson} alt="" />{" "}
        </div>
        <div
          className="chat-text"
          style={{ margin: "10px 10px" }}
          aria-live="polite"
          dangerouslySetInnerHTML={{ __html: props.item.text }}
        ></div>
      </div>
    </>
  );
};

export default MessageA3;
